import React from "react";
import styled from "styled-components";

import { NavigationProvider } from "@origin-digital/navigation-client-sdk";
import {
  Box,
  Column,
  Columns,
  Hidden,
  Section,
} from "@origin-digital/ods-core";

import { DesktopNav } from "./Desktop/DesktopNav";
import { authNavRoutePrefix } from "./helpers/consts";
import { IKrakenAuthNavProps } from "./interfaces";
import { MobileNav } from "./Mobile/MobileNav";
import SmallerLogo from "./SmallerLogo";

const StyledBox = styled(Box)(({ theme: { palette } }) => ({
  borderBottom: `1px solid ${palette.borderColor.primary}`,
}));

export const KrakenAuthNav: React.FC<IKrakenAuthNavProps> = ({
  desktopVariant,
}) => {
  const showFullHeader = desktopVariant !== "slim";
  const menuDataId = showFullHeader ? "kraken-auth-nav" : "no-nav-header";

  return (
    <StyledBox data-id={menuDataId} component="nav" aria-label="Main">
      <Section paddingY="none" data-id="desktop-container">
        <Box display="flex" width="full">
          <Columns space="none">
            <Column width="content">
              <SmallerLogo
                id="origin-logo"
                href={authNavRoutePrefix}
                desktopVariant={desktopVariant}
              />
            </Column>
            {showFullHeader ? (
              <>
                <Column width="flex" alignX="right">
                  <NavigationProvider>
                    <>
                      <Hidden below="lg">
                        <DesktopNav />
                      </Hidden>
                      <Hidden above="lg">
                        <MobileNav />
                      </Hidden>
                    </>
                  </NavigationProvider>
                </Column>
              </>
            ) : null}
          </Columns>
        </Box>
      </Section>
    </StyledBox>
  );
};
